import { render, staticRenderFns } from "./indexTotal.vue?vue&type=template&id=442178fa&scoped=true"
import script from "./indexTotal.vue?vue&type=script&lang=js"
export * from "./indexTotal.vue?vue&type=script&lang=js"
import style0 from "./indexTotal.vue?vue&type=style&index=0&id=442178fa&prod&lang=scss"
import style1 from "./indexTotal.vue?vue&type=style&index=1&id=442178fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442178fa",
  null
  
)

export default component.exports